import fetch from "@lib/fetch";
import {API} from "../../config";

export const cancelTopUp = (token, trxId) => {
    return fetch(`${API}/v1/wallets/topups/${trxId}/cancel`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json()
        })
        .catch(error => {
            console.log(error);
        })
};

export const getAdminTransactions = (token) => {
    return fetch(`${API}/v1/admin/transactions`,{
        mode: 'cors',
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};

export const adminAcceptTransactions = (trxId, token) => {
    return fetch(`${API}/v1/wallets/topups/${trxId}/accept`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};


export const adminRejectTransactions = (trxId, token) => {
    return fetch(`${API}/v1/wallets/topups/${trxId}/reject`,{
        mode: 'cors',
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json()
    })
    .catch(error => {
        console.log(error);
    })
};
